import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "/assets/img/logo-small.svg"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "training-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "/assets/img/title-training.svg",
    width: "600",
    height: "192"
  })
], -1)

import {inject, onMounted} from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { examKey } from "@/main";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Training',
  emits: ['overridePageName'],
  setup(__props) {

const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const group = route.params.group;
const page = parseInt(typeof route.params.page === 'string' ? route.params.page : route.params.page[0]);
const examType = route.params.examtype;

const next = () => {
  router.replace(`/cbt/${group}/${examType}/${page}`);
}

let timeoutId: number | null = null;

onMounted(() => {
  timeoutId = setTimeout(() => {
    next();
  }, 2000);
})

const demoPrev = () => {
  if (timeoutId) clearTimeout(timeoutId);
  router.replace(`/cbt/${group}/${examType}/${page}/flow`);
}
const demoNext = () => {
  if (timeoutId) clearTimeout(timeoutId);
  next();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "m-logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exam).isDebug() && next()))
    }, _hoisted_2),
    _hoisted_3,
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})